import { Component, Input } from '@angular/core';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
@Component({
  selector: 'app-event-share',
  templateUrl: './event-share.component.html',
  styleUrls: ['./event-share.component.scss']
})
export class EventShareComponent {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventShareObj: any;
  @Input() data;
  api_in_process = false;
  constructor(public fcs: FunCollectionService, public mls: NewLanguageService) { }
  // share
  productshare(): void {
    // this.eventShareObj = this.eventShareObj;
    //  console.log(this.data)
    this.fcs.productShare(this.data.data);
  }


}
